function getAuthHeaders(access_token: string | undefined) {
  return {
    Authorization: `Bearer ${access_token}`,
    "Access-Control-Allow-Origin": "*",
  };
}

export default getAuthHeaders;
